export const SET_PROGRAM_NOTICES = "SET_PROGRAM_NOTICES";

export const SET_LOADED_STATUS = "SET_LOADED_STATUS";

export const SET_ORGANIZATION_NOTICE = "SET_ORGANIZATION_NOTICE";
